import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../../constant/Environment"
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  fetchAllData
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { TextareaAutosize } from "@mui/material";

import Switch from "@mui/material/Switch";

const AddNote = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const[description,setdescription]= useState("");
  const state = useSelector((state) => state);


  // state.auth?.user?.data?.idUser

  React.useEffect(() => {
    if (open) {
      setdescription(editData?.note);
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };
  console.log("isActive", editData);
  const handleOk = () => {
    let url = editData?.id
      ? `${endPoints.api.UPDATE_NOTE}`
      : `${endPoints.api.CREATE_NOTE}`;
    let payload = {
      // description: description
      note: description,
      idUser: props.userid,
      createdBy: state.auth?.user?.data?.idUser
    };
    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      {...other}
    >
      <DialogTitle>ADD Note </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextareaAutosize
            id="filled-required"
            variant="outlined"
            label="note"
            value={description}
            onChange={(event) => {
              setdescription(event.target.value);
            }}
            style={{height:"90px",paddingInline:"5px"}}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNote;
